import { h } from 'preact';
import { StatusBadge } from '../StatusBadge';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'StatusBadge',
  category: '📊 Data Display',
  description: 'Badge de status com dot colorido (online, offline, warning, error, info)',
  usedIn: ['Integrations', 'AgentesPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
      <StatusBadge variant="online" label="Online" />
      <StatusBadge variant="offline" label="Offline" />
      <StatusBadge variant="warning" label="Pendente" />
      <StatusBadge variant="error" label="Erro" />
      <StatusBadge variant="info" label="Info" size="sm" />
    </div>
  ),
};
